import Swiper from "swiper"
import {Navigation, Pagination} from "swiper/modules"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"

export default () => {
	const sliders = document.querySelectorAll('.block.home-hero .swiper') as NodeListOf<HTMLDivElement>

	if (!sliders) return

	sliders.forEach(slider => {
		new Swiper(slider, {
			modules: [Navigation, Pagination],
			direction: "horizontal",
			slidesPerView: 1,
			loop: true,
			autoHeight: true,
			allowTouchMove: true,
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next') as HTMLDivElement,
				prevEl: slider.querySelector('.swiper-button-prev') as HTMLDivElement,
			},
			pagination: {
				el: slider.querySelector('.swiper-pagination') as HTMLDivElement,
			},
		})
	})
}
